<template>
    <div>
<!--        Invoice payment received by-->
<!--        <strong>{{ getActorName() }} </strong>-->
        <span v-html="$t('notification.invoicePaymentReceived', {user: getActorName() })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "InvoicePaymentReceived",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
